class Filter<Value = any> {
  /**
   * Return the filter data to put in the bookmark config
   */
  toBookmarkConfiguration(): any {
    return {};
  }

  getValue(): Value {
    throw new Error('getValue not implemented');
  }

  /**
   * True if the filter has a user defined value. Some screens will use this to
   * decide if the filter is active.
   */
  get hasValue(): boolean {
    throw new Error('hasValue not implemented');
  }

  matches(record: any): boolean {
    throw new Error('matches not implemented');
  }
}

export default Filter;
